import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Grid,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { UserInterestPayload } from "../../../api/UserInterestApi";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useState } from "react";

type MenuType = "days" | "hours" | null;

const daysOptions = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

const hoursOptions = [
  { label: "Morning", value: "morning" },
  { label: "Afternoon", value: "afternoon" },
  { label: "Evening", value: "evening" },
  { label: "Overnight", value: "overnight" },
];

const EngagmentWithPlatform: React.FC<{
  onHoursChange: (val: string) => void;
  onDaysChange: (val: string) => void;
  formData: UserInterestPayload;
}> = ({ formData, onHoursChange, onDaysChange }) => {
  const [activeMenu, setActiveMenu] = useState<MenuType>(null);

  return (
    <FormControl maxW="368px" alignSelf="center">
      <FormLabel color="gray.500" fontSize="12px" fontWeight="700">
        Are you interested in any specific hours or days of the week?
      </FormLabel>
      <Grid templateColumns="repeat(2, 1fr)" gap={4}>
        <Menu
          isOpen={activeMenu === "days"}
          onClose={() => setActiveMenu(null)}
          onOpen={() => setActiveMenu("days")}
          closeOnSelect={false}
        >
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            variant="outline"
            w="full"
            height={14}
            textAlign="left"
            borderColor="gray.300"
            color={`gray.${formData.availabilityPreferences.days.length ? 800 : 400}`}
            fontWeight="400"
          >
            {formData.availabilityPreferences.days.length
              ? `${formData.availabilityPreferences.days.length} days selected`
              : "Days"}
          </MenuButton>
          <MenuList>
            {daysOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onDaysChange(option.value);
                }}
              >
                <HStack justify="space-between" width="100%">
                  <Checkbox
                    isChecked={formData.availabilityPreferences.days.includes(option.value)}
                    colorScheme="brandBlue"
                  />
                  <Text flex="1">{option.label}</Text>
                </HStack>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>

        <Menu
          isOpen={activeMenu === "hours"}
          onClose={() => setActiveMenu(null)}
          onOpen={() => setActiveMenu("hours")}
          closeOnSelect={false}
        >
          <MenuButton
            as={Button}
            rightIcon={<ChevronDownIcon />}
            variant="outline"
            height={14}
            w="full"
            textAlign="left"
            color={`gray.${formData.availabilityPreferences.hours.length ? 800 : 400}`}
            fontWeight="400"
          >
            {formData.availabilityPreferences.hours.length
              ? `${formData.availabilityPreferences.hours.length} times selected`
              : "Hours"}
          </MenuButton>
          <MenuList>
            {hoursOptions.map((option) => (
              <MenuItem
                key={option.value}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onHoursChange(option.value);
                }}
              >
                <HStack justify="space-between" width="100%">
                  <Checkbox
                    isChecked={formData.availabilityPreferences.hours.includes(
                      option.value,
                    )}
                    colorScheme="brandBlue"
                  />
                  <Text color="gray.600" textStyle="smMdSemi" flex="1">
                    {option.label}
                  </Text>
                </HStack>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Grid>
    </FormControl>
  );
};

export default EngagmentWithPlatform;
